import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "./ui/breadcrumb";
import { Loader2, PencilLine, SlashIcon, Trash2 } from "lucide-react";
import "../Styles/Results.css";
// import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "./ui/table";
// import { useAuth } from "../context/AuthContext";
import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
// import { useCart } from "../context/CartContext";
// import LoadingButton from "./LoadingButton";
import { useProjectId } from "../context/ProjectIdContext";
import { Toast, ToastDescription, ToastTitle, ToastViewport } from "./ui/toast";
import { useCallback } from "react";

const API_URL = process.env.REACT_APP_API_URL; // Ensure this matches your backend URL

const ProjectEstimator = () => {
  // const location = useLocation();

  // const projectId = location.state?.projectId;

  const { projectId } = useProjectId();

  // console.log(projectId)
  const navigate = useNavigate();
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  const credentials = `${username}:${password}`;
  const encodedCredentials = btoa(credentials); // Base64 encode the credentials

  const [data, setData] = useState([]); // State to store fetched data
  const [finalData, setFinalData] = useState([]); // State to store fetched data
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage] = useState("Project Estimator");
  // const { userSession } = useAuth(); // Get session and logout from context
  const [deleteId, setDeleteId] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  // const [selectedTable, setSelectedTable] = useState(null); // State for selected table'
  // const { addToCart, handleCount } = useCart();
  const [toastList, setToastList] = useState([]);

  const [resin, setResin] = useState("");
  const [selectedClasses, setSelectedClasses] = useState({});
  const [pendingSelection, setPendingSelection] = useState(null);
  const [pendingIndex, setPendingIndex] = useState(null);
  const [isClassIVDialogOpen, setIsClassIVDialogOpen] = useState(false);
  const [isSavingClassSelection, setIsSavingClassSelection] = useState(false);
  const [resinCost, setResinCost] = useState("");

  const [projectDetails, setProjectDetails] = useState({
    title: "",
    location: "",
    clientName: "",
    sippInstaller: "",
    sippCalcDesignDate: "",
  });

  // const userType = userSession.userType;

  // const data = {
  //   partiallyDeteriorated: {
  //     tX1_1: 0.5,
  //     tX1_5: true,
  //     tX1_6: 0.3,
  //     partiallyDesignThickness: 0.4,
  //     partiallyPasses: 3,
  //   },
  //   fullyDeteriorated: {
  //     tX1_1: 0.6,
  //     tX1_3: 0.7,
  //     tX1_7: 0.8,
  //     fullyDesignThickness: 0.9,
  //     fullyPasses: 4,
  //   },
  // };

  // const token = localStorage.getItem("x-auth-token");
  // console.log(token)

  // Fetching Project details
  useEffect(() => {
    const username = process.env.REACT_APP_API_USERNAME;
    const password = process.env.REACT_APP_API_PASSWORD;
    const credentials = `${username}:${password}`;
    const encodedCredentials = btoa(credentials); // Base64 encode the credentials

    // if (!fetchedProjectId) {
    //   console.warn("fetchProjectDetails skipped: No project ID provided yet.");
    //   return;
    // }

    const fetchProjectDetails = async () => {
      if (!projectId) {
        console.error("No project ID provided.");
        return;
      }

      try {
        // const token = localStorage.getItem("x-auth-token"); // Retrieve token
        // console.log(token)
        const response = await fetch(`${API_URL}/api/project/${projectId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${encodedCredentials}`, // Basic Auth header
          },
        });

        if (response.ok) {
          const result = await response.json();
          const project = result.data.data.project;

          // console.log("Project details fetched:", project);

          // Update state with fetched project details
          setProjectDetails({
            title: project.title,
            location: project.location,
            clientName: project.clientName,
            sippInstaller: project.sippInstaller,
            sippCalcDesignDate: project.sippCalcDesignDate,
          });
        } else {
          setError("Failed to fetch results. Please Sign in and try again.");
          console.error("Error fetching results:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching project details:", error);
      }
    };

    fetchProjectDetails();
  }, [projectId]); // Only runs when the `projectId` changes

  const postSelectedClasses = useCallback(
    async (selections) => {
      setIsSavingClassSelection(true);

      const payload = {
        projectId,
        ...Object.entries(selections).reduce((acc, [index, value]) => {
          acc[`classSelectedForSection${Number(index) + 1}`] = value;
          return acc;
        }, {}),
      };

      // console.log(payload);

      try {
        const response = await fetch(
          `${API_URL}/api/project/select-class/estimate`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Basic ${encodedCredentials}`,
            },
            body: JSON.stringify(payload),
          },
        );

        if (response.ok) {
          const result = await response.json();
          const totalData = result.data.data;

          setFinalData(totalData);
        } else {
          console.error("Error in total:", response.statusText);
        }
      } finally {
        setIsSavingClassSelection(false);
      }
    },
    [projectId, encodedCredentials],
  );
  const handleConfirmClassIV = () => {
    setSelectedClasses((prev) => {
      const updated = {
        ...prev,
        [pendingIndex]: pendingSelection,
      };
      postSelectedClasses(updated);
      return updated;
    });

    setIsClassIVDialogOpen(false);
    setPendingSelection(null);
    setPendingIndex(null);
  };

  const handleClassChange = useCallback(
    (index, selectedClass) => {
      if (selectedClass === "IV") {
        setPendingSelection("IV");
        setPendingIndex(index);
        setIsClassIVDialogOpen(true);
      } else {
        setSelectedClasses((prev) => {
          const updated = { ...prev, [index]: selectedClass };
          postSelectedClasses(updated);
          return updated;
        });
      }
    },
    [postSelectedClasses],
  );

  const handleCancelClassIV = () => {
    setPendingSelection(null); // Clear selection
    setIsClassIVDialogOpen(false); // Close dialog
  };

  const handleConfirmDelete = () => {
    if (deleteId) {
      document.activeElement?.blur(); // Prevent focus error
      handleDelete(deleteId); // Delete the item
    }
    setIsDialogOpen(false); // Close the dialog
    setTimeout(() => setDeleteId(null), 200); // Reset deleteId safely
  };

  const handleCancelDelete = () => {
    setIsDialogOpen(false); // Close the dialog
    setTimeout(() => setDeleteId(null), 200); // Reset deleteId safely
  };

  // const handleAddToCart = () => {
  //   if (!selectedTable) {
  //     setToastList((prev) => [
  //       ...prev,
  //       {
  //         id: Date.now(),
  //         title: "ERROR!",
  //         description:
  //           "Please select a table (Class II, III or Class IV) first!",
  //         variant: "destructive",
  //       },
  //     ]);

  //     return;
  //   }

  //   setIsLoading(true);
  //   // Simulate a delay (e.g., for navigation or API call)
  //   setTimeout(() => {
  //     setIsLoading(false);
  //     navigate("/nextsteps3");
  //   }, 3000);

  //   const selectedData =
  //     selectedTable === "Class II"
  //       ? data.calculations.map((item) => ({
  //           internalDiameter: item.internalDiameter,
  //           lengthLined: item.lengthLined,
  //           linerVol: item.addedClassII?.linerVolII,
  //           drumsResin: item.addedClassII?.drumsResinII,
  //           estimatedTotalResin: data.analysis.classII?.estimateResinVol,
  //           estimatedTotalDrums: data.analysis.classII?.estimateDrums,
  //           estimatedTotalCost: data.analysis.classII?.totalCost,
  //           type: "Class II",
  //         }))
  //       : selectedTable === "Class III"
  //       ? data.calculations.map((item) => ({
  //           internalDiameter: item.internalDiameter,
  //           lengthLined: item.lengthLined,
  //           linerVol: item.partiallyDeteriorated?.linerVolIII,
  //           drumsResin: item.partiallyDeteriorated?.drumsResinIII,
  //           estimatedTotalResin: data.analysis.classIII?.estimateResinVol,
  //           estimatedTotalDrums: data.analysis.classIII?.estimateDrums,
  //           estimatedTotalCost: classIIITotalCost,
  //           type: "Class III",
  //         }))
  //       : data.calculations.map((item) => ({
  //           internalDiameter: item.internalDiameter,
  //           lengthLined: item.lengthLined,
  //           tX1_1: item.fullyDeteriorated?.tX1_1,
  //           tX1_3: item.fullyDeteriorated?.tX1_3,
  //           tX1_7: item.fullyDeteriorated?.tX1_7,
  //           linerVol: item.fullyDeteriorated?.linerVolIV,
  //           drumsResin: item.fullyDeteriorated?.drumsResinIV,
  //           fullyDesignThickness: item.fullyDeteriorated?.fullyDesignThickness,
  //           fullyInstallThickness:
  //             item.fullyDeteriorated?.fullyInstallThickness,
  //           fullyPasses: item.fullyDeteriorated?.fullyPasses,
  //           estimatedTotalResin: data.analysis.classIV?.estimateResinVol,
  //           estimatedTotalDrums: data.analysis.classIV?.estimateDrums,
  //           estimatedTotalCost: classIVTotalCost,
  //           type: "Class IV",
  //         }));

  //   addToCart({ type: selectedTable, items: selectedData });
  //   handleCount();
  //   // navigate("/checkout");
  //   setToastList((prev) => [
  //     ...prev,
  //     {
  //       id: Date.now(),
  //       title: "ERROR!",
  //       description: "Added to Cart!",
  //       variant: "default",
  //     },
  //   ]);
  // };

  // Fetch data from the API
  useEffect(() => {
    const username = process.env.REACT_APP_API_USERNAME;
    const password = process.env.REACT_APP_API_PASSWORD;
    const credentials = `${username}:${password}`;
    const encodedCredentials = btoa(credentials); // Base64 encode the credentials

    const fetchData = async () => {
      try {
        const response = await fetch(`${API_URL}/api/project/${projectId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${encodedCredentials}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch project data");
        }

        const result = await response.json();
        const project = result.data.data;

        // console.log(project);

        setData(project);

        const calculations = project.calculations || [];

        // Hydrate saved selections OR default to III
        const initialSelections = {};
        calculations.forEach((_, index) => {
          initialSelections[index] =
            project.selectedClasses?.[`section${index + 1}`] || "III";
        });

        setSelectedClasses(initialSelections);

        // Safe guards
        if (calculations.length > 0) {
          setResin(calculations[0]?.requestData?.resin ?? "");
        }

        setResinCost(Number(project.resinCost ?? 0));
      } catch (error) {
        console.error("Error fetching results:", error);
        setError("An error occurred while fetching results.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [projectId, encodedCredentials]);

  const hasInitializedDefaults = React.useRef(false);

  useEffect(() => {
    if (!projectId) return;
    if (!data?.calculations?.length) return;
    if (hasInitializedDefaults.current) return;

    hasInitializedDefaults.current = true;

    data.calculations.forEach((_, index) => {
      handleClassChange(index, "III");
    });
  }, [projectId, data, handleClassChange]);

  // CLASS DATA RESOLVER
  const resolveClassData = (calc, classSelected) => {
    switch (classSelected) {
      case "I":
        return {
          linerVol: calc.addedClassI?.linerVolI ?? 0,
          drums: calc.addedClassI?.drumsResinI ?? 0,
        };

      case "II":
        return {
          linerVol: calc.addedClassII?.linerVolII ?? 0,
          drums: calc.addedClassII?.drumsResinII ?? 0,
        };

      case "IV":
        return {
          linerVol: calc.fullyDeteriorated?.linerVolIV ?? 0,
          drums: calc.fullyDeteriorated?.drumsResinIV ?? 0,
        };

      case "III":
      default:
        return {
          linerVol: calc.partiallyDeteriorated?.linerVolIII ?? 0,
          drums: calc.partiallyDeteriorated?.drumsResinIII ?? 0,
        };
    }
  };

  //Use for Appjs later??
  // const handleAddToCart = () => {
  //   if (selectedTable) {
  //     addToCart(selectedTable); // Use addToCart from context
  //     navigate("/checkout");
  //   } else {
  //     alert("Please select a table to add to cart.");
  //   }
  // };

  // const handleSaveAll = async () => {
  //   const ids = data.map((item) => item._id);

  //   try {
  //     const token = localStorage.getItem("x-auth-token");
  //     const response = await fetch(`${API_URL}/api/calculate/keep`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Basic ${encodedCredentials}`,
  //         "x-auth-token": token,
  //       },
  //       body: JSON.stringify({ calculationIds: ids }),
  //     });

  //     if (response.ok) {
  //       const result = await response.json();
  //       setAlert({
  //         message: result.message || "All calculations saved successfully!",
  //         type: "default",
  //         visible: true,
  //       });
  //     } else {
  //       setAlert({
  //         message: "Failed to save calculations. Please try again.",
  //         type: "destructive",
  //         visible: true,
  //       });
  //       console.error("Error saving calculations:", response.statusText);
  //     }
  //   } catch (error) {
  //     setAlert({
  //       message: "An error occurred while saving calculations.",
  //       type: "destructive",
  //       visible: true,
  //     });
  //     console.error("Error with save:", error);
  //   }
  // };

  if (isLoading) {
    return (
      <div className="tw-flex tw-items-center tw-justify-center tw-h-screen">
        <Loader2 className="tw-animate-spin tw-h-10 tw-w-10 tw-text-[#00B5ED]" />
      </div>
    );
  }

  const handleReview = (requestData, id) => {
    navigate("/calculator", {
      state: {
        projectId: projectId,
        requestData: {
          ...requestData,
          performRecalculation: true, //  Set recalculation mode
          existingCalculationId: id, // Include existing calculation ID
        },
      },
    });
  };

  const handleDelete = async (id) => {
    if (!id) return;

    try {
      const token = localStorage.getItem("x-auth-token"); // Retrieve token
      const response = await fetch(`${API_URL}/api/calculate/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${encodedCredentials}`, // Basic Auth header
          "x-auth-token": token,
        },
      });

      if (response.ok) {
        setData((prevData) => {
          // Ensure `prevData` is correctly structured
          if (!prevData || !prevData.calculations) return prevData;

          return {
            ...prevData,
            calculations: prevData.calculations.filter(
              (item) => item._id !== id,
            ),
          };
        });
      } else {
        console.error("Failed to delete the item.");
      }
    } catch (err) {
      console.error("Error during deletion:", err);
    }
  };

  if (error) {
    return <div className="tw-mt-44 tw-h-screen">{error}</div>;
  }

  if (!data) {
    return <div className="tw-mt-44 tw-h-screen">No results to display.</div>;
  }

  const breadcrumbs = [
    {
      label: "Project Information",
      link: "/projectinfo",
      isCurrent: currentPage === "ProjectInfo",
    },
    {
      label: "Calculator",
      link: "/calculator",
      isCurrent: currentPage === "Calculator",
    },
    {
      label: "Design Summary",
      link: "/designsummary",
      isCurrent: currentPage === "Design Summary",
    },
    {
      label: "Project Estimator",
      link: "/projectestimator",
      isCurrent: currentPage === "Project Estimator",
    },
  ];

  // const onPrint = (e) => {
  //   e.preventDefault();
  //   window.print();
  // };

  const removeToast = (id) => {
    setToastList((prev) => prev.filter((toast) => toast.id !== id));
  };

  return (
    <div className="tw-mt-28 md:tw-mt-44 tw-w-full">
      {/* Breadcrumbs */}
      <div>
        <Breadcrumb>
          <BreadcrumbList>
            {breadcrumbs.map((breadcrumb, index) => (
              <React.Fragment key={index}>
                <BreadcrumbItem>
                  {breadcrumb.isCurrent ? (
                    // Render the current page without a link
                    <BreadcrumbPage>{breadcrumb.label}</BreadcrumbPage>
                  ) : (
                    // Render the previous pages without links
                    <BreadcrumbLink>{breadcrumb.label}</BreadcrumbLink>
                  )}
                </BreadcrumbItem>
                {index < breadcrumbs.length - 1 && (
                  <BreadcrumbSeparator>
                    <SlashIcon />
                  </BreadcrumbSeparator>
                )}
              </React.Fragment>
            ))}
          </BreadcrumbList>
        </Breadcrumb>
      </div>

      <h1 className="tw-flex tw-text-base md:tw-text-lg tw-font-bold tw-mb-10 md:tw-mb-10 tw-justify-center tw-underline">
        Project Estimates
      </h1>

      {/* Change to Information from backend */}
      <div className="tw-my-6">
        <ul>
          <li>
            <span className="tw-font-semibold tw-text-[#00B5ED]">
              Project Title:
            </span>{" "}
            {projectDetails.title}
          </li>
          <li>
            <span className="tw-font-semibold tw-text-[#00B5ED]">
              Project Location:
            </span>{" "}
            {projectDetails.location}
          </li>
          <li>
            <span className="tw-font-semibold tw-text-[#00B5ED]">Client:</span>{" "}
            {projectDetails.clientName}
          </li>
          <li>
            <span className="tw-font-semibold tw-text-[#00B5ED]">
              SIPP Installer:
            </span>{" "}
            {projectDetails.sippInstaller}
          </li>
          <li>
            <span className="tw-font-semibold tw-text-[#00B5ED]">
              SIPP Calc Design Date:
            </span>{" "}
            {projectDetails.sippCalcDesignDate}
          </li>
        </ul>
      </div>

      {/* <div className="tw-flex tw-justify-between tw-items-center tw-mb-4">
        <div className="tw-flex tw-items-center tw-justify-evenly md:tw-justify-end tw-space-x-8 tw-my-10 tw-w-full">
          <Button variant="default" className="" onClick={onPrint}>
            <div className="tw-font-semibold tw-text-sm">Print Summary</div>
          </Button>

          <Link to="/calculator">
            <Button variant="default" className="">
              <div className="tw-font-semibold tw-text-sm">Add New Design</div>
            </Button>
          </Link>
        </div>
      </div> */}

      {/* <div className="tw-flex tw-items-center tw-justify-end">
        <Button
          variant="default"
          className="tw-shadow-none tw-items-center tw-font-semibold  tw-bg-green-500 hover:tw-bg-green-600 tw-mb-4"
          onClick={handleAddToCart}
        >
          <FolderCheck className="tw-h-6 tw-w-6 tw-mr-1 tw-mb-0.5" />
          Add to Cart
        </Button>
      </div> */}

      <p className="tw-font-semibold tw-text-md md:tw-text-lg tw-mb-4">
        Choose a design type to proceed with:
      </p>

      <p className="tw-font-medium tw-text-sm tw-italic tw-mb-4">
        NOTE: SIPP Americas currently recommends a Class III design as long as
        the pressure pipe is partially deteriorated
      </p>

      {/* Class Design Table */}
      <div className="md:tw-flex tw-justify-between tw-items-start tw-space-x-2">
        {/* <input
          className="tw-w-6 tw-mt-2 tw-h-6 tw-border-2 tw-rounded-full focus:tw-outline-none focus:tw-ring-0 active:tw-ring-0 tw-accent-[#00B5ED]"
          type="radio"
          name="tableSelection"
          value="Class II"
          checked={selectedTable === "Class II"}
          // onChange={() => handleRadioChange("Class II")}
        /> */}
        <div
          className="tw-mb-12 tw-w-full"
          // onClick={() => setSelectedTable("Class II")}
        >
          <h2
            className="tw-text-sm tw-cursor-pointer md:tw-text-base tw-font-bold tw-bg-[#00B5ED] tw-text-white tw-p-2 tw-uppercase tw-mb-2 tw-rounded-t-md"
            // onClick={() => handleRadioChange("Class II")}
          >
            Liner Design
          </h2>
          <Table className="tw-pb-4 tw-border-collapse tw-border tw-border-black">
            <TableHeader>
              <TableRow className="tw-border tw-border-black">
                <TableHead className="tw-border tw-border-black">
                  Pipe Section No.
                </TableHead>
                <TableHead className="tw-border tw-border-black">
                  Class Design
                </TableHead>
                <TableHead className="tw-border tw-border-black">
                  Pipe ID (in)
                </TableHead>
                <TableHead className="tw-border tw-border-black">
                  SIPP Liner Length (ft)
                </TableHead>
                {/* <TableHead className="tw-border tw-border-black">
                  t for X1.1 (mm)
                </TableHead>
                <TableHead className="tw-border tw-border-black">
                  t for X1.6/X1.7 (mm)
                </TableHead>
                <TableHead className="tw-border tw-border-black">
                  Design t (mm)
                </TableHead>
                <TableHead className="tw-border tw-border-black">
                  Install t (mm)
                </TableHead>
                <TableHead className="tw-border tw-border-black">
                  No. of Passes
                </TableHead>
                <TableHead className="tw-border tw-border-black">
                  Design Assumes
                </TableHead> */}
                <TableHead className="tw-border tw-border-black">
                  Resin Vol (ltrs)
                </TableHead>
                <TableHead className="tw-border tw-border-black">
                  Drums
                </TableHead>
                <TableHead className="tw-border tw-border-black">
                  Actions
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.calculations.map((item, index) => (
                <TableRow key={index} className="tw-border tw-border-black">
                  <TableCell className="tw-border tw-border-black">
                    {index + 1}
                  </TableCell>
                  <TableCell className="tw-border tw-border-black">
                    <select
                      className="tw-bg-[#00B5ED]/30 tw-rounded-md tw-py-1"
                      disabled={isSavingClassSelection}
                      value={selectedClasses[index] || "III"}
                      onChange={(e) => handleClassChange(index, e.target.value)}
                    >
                      <option value="I">Class I</option>
                      <option value="II">Class II</option>
                      <option value="III">Class III</option>
                      <option value="IV">Class IV</option>
                    </select>
                  </TableCell>
                  <TableCell className="tw-border tw-border-black">
                    {item.internalDiameter ?? "NULL"}
                  </TableCell>
                  <TableCell className="tw-border tw-border-black">
                    {item.lengthLined ?? "NULL"}
                  </TableCell>
                  {/* <TableCell className="tw-border tw-border-black">
                    {item.partiallyDeteriorated.tX1_1 ?? "NULL"}
                  </TableCell>
                  <TableCell className="tw-border tw-border-black">
                    {item.partiallyDeteriorated.tX1_6 ?? "NULL"}
                  </TableCell>
                  <TableCell className="tw-border tw-border-black">
                    {item.partiallyDeteriorated.partiallyDesignThickness ??
                      "NULL"}
                  </TableCell>
                  <TableCell className="tw-border tw-border-black">
                    {item.partiallyDeteriorated.partiallyInstallThickness ??
                      "NULL"}
                  </TableCell>
                  <TableCell className="tw-border tw-border-black">
                    {item.partiallyDeteriorated.partiallyPasses ?? "NULL"}
                  </TableCell>
                  <TableCell className="tw-border tw-border-black">
                    {item.vacuumCondition ?? "NULL"}
                  </TableCell> */}
                  {/* <TableCell className="tw-border tw-border-black">
                    {item.addedClassII.linerVolII ?? "NULL"}
                  </TableCell>
                  <TableCell className="tw-border tw-border-black">
                    {item.addedClassII.drumsResinII ?? "NULL"}
                  </TableCell> */}

                  {(() => {
                    const selectedClass = selectedClasses[index] || "III";
                    const { linerVol, drums } = resolveClassData(
                      item,
                      selectedClass,
                    );

                    return (
                      <>
                        <TableCell className="tw-border tw-border-black">
                          {linerVol || "NULL"}
                        </TableCell>
                        <TableCell className="tw-border tw-border-black">
                          {drums || "NULL"}
                        </TableCell>
                      </>
                    );
                  })()}

                  <TableCell className="">
                    <div className="tw-flex tw-space-x-2 tw-justify-center">
                      {/* Review Button */}
                      <div className="tw-inline-block">
                        <button
                          onClick={() =>
                            handleReview(item.requestData, item._id)
                          }
                          className="tw-text-white tw-py-1 tw-px-4 tw-text-xs tw-font-semibold tw-bg-[#00B5ED] tw-shadow-sm hover:tw-bg-primary/90"
                        >
                          <PencilLine className="tw-w-4 tw-h-4 tw-font-bold" />
                        </button>
                      </div>

                      {/* Delete Button */}
                      <AlertDialog
                        key={item._id}
                        open={isDialogOpen && deleteId === item._id}
                        onOpenChange={(open) => {
                          if (!open) {
                            setTimeout(() => {
                              setDeleteId(null);
                            }, 200);
                          }
                          setIsDialogOpen(open);
                        }}
                      >
                        <AlertDialogTrigger asChild>
                          <button
                            onClick={() => {
                              setDeleteId(item._id);
                              setIsDialogOpen(true);
                            }}
                            className="tw-text-white tw-py-1 tw-px-4 tw-text-xs tw-font-semibold tw-bg-destructive tw-shadow-sm hover:tw-bg-destructive/90"
                          >
                            <Trash2 className="tw-w-4 tw-h-4 tw-font-bold" />
                          </button>
                        </AlertDialogTrigger>

                        <AlertDialogContent>
                          <AlertDialogHeader>
                            <AlertDialogTitle>
                              Confirm Deletion
                            </AlertDialogTitle>
                            <AlertDialogDescription>
                              Are you sure you want to delete this result
                              permanently? This action cannot be undone.
                            </AlertDialogDescription>
                          </AlertDialogHeader>

                          <AlertDialogFooter>
                            <AlertDialogCancel
                              className="tw-border-2"
                              onClick={handleCancelDelete}
                            >
                              Cancel
                            </AlertDialogCancel>

                            <AlertDialogAction
                              className="tw-bg-destructive mb-2"
                              onClick={handleConfirmDelete}
                            >
                              Confirm
                            </AlertDialogAction>
                          </AlertDialogFooter>
                        </AlertDialogContent>
                      </AlertDialog>
                    </div>
                  </TableCell>
                </TableRow>
              ))}

              <TableRow className="tw-border tw-border-black">
                <TableCell className="tw-border tw-border-black">
                  Total
                </TableCell>
                <TableCell
                  className="tw-border tw-border-black"
                  colSpan={3}
                ></TableCell>
                <TableCell className="tw-border tw-border-black">
                  {data.calculations.reduce((sum, item, index) => {
                    const selectedClass = selectedClasses[index] || "III";
                    return sum + resolveClassData(item, selectedClass).linerVol;
                  }, 0)}
                </TableCell>
                {/* <TableCell
                  className="tw-border tw-border-black"
                  colSpan={4}
                ></TableCell>
                <TableCell className="tw-border tw-border-black">
                  {data.analysis.classIII.totalResinVolume ?? "NULL"}
                </TableCell>
                <TableCell className="tw-border tw-border-black">
                  {data.analysis.classIII.totalDrums ?? "NULL"}
                </TableCell> */}
              </TableRow>

              {/*  Empty Row for Spacing */}
              <TableRow>
                <TableCell className="tw-h-10" colSpan={5}></TableCell>
              </TableRow>

              {/* Estmated Total Resin */}
              <TableRow className="">
                <TableCell className="" colSpan={2}></TableCell>
                <TableCell className=" tw-font-medium tw-text-base" colSpan={2}>
                  Total Resin
                </TableCell>
                <TableCell className="tw-border tw-border-black tw-font-medium tw-text-base">
                  {finalData.estimateResinVol ?? "--"}
                </TableCell>
                <TableCell className="tw-border tw-border-black tw-font-medium tw-text-base">
                  {finalData.estimateDrums ?? "--"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <div className="tw-flex tw-flex-col tw-space-y-2 tw-text-xs tw-border-x tw-border-b tw-p-4 tw-border-black">
            {/* <p className="tw-font-medium tw-flex tw-justify-end tw-text-base">
              Cost per Resin Vol ={" "}
              <span className="tw-text-[#00B5ED] tw-font-semibold tw-text-xl">
                ${parseFloat(resinCost).toLocaleString()}
              </span>
            </p>
            <p className="tw-font-medium tw-flex tw-justify-end tw-text-base">
              {(() => {
                 const totalDrums = data.analysis.estimateDrums

           
                return (
                  <>
                    Resin cost for the {totalDrums} drums for Resiline {resin} =
                    <span className="tw-text-[#00B5ED] tw-font-semibold tw-text-xl">
                      ${(totalDrums * resinCost).toLocaleString()}
                    </span>
                  </>
                );
              })()}
            </p>
            
             <p className="tw-font-medium tw-flex tw-justify-end tw-text-base">
              Cost per Resin Vol ={" "}
              <span className="tw-text-[#00B5ED] tw-font-semibold tw-text-xl">
                ${parseFloat(resinCost).toLocaleString()}
              </span>
            </p> */}

            <p className="tw-font-medium tw-flex tw-justify-end tw-text-base">
              Cost per Resin Vol ={" "}
              <span className="tw-text-[#00B5ED] tw-font-semibold tw-text-xl">
                ${parseFloat(resinCost).toLocaleString()}
              </span>
            </p>

            <p className="tw-font-medium tw-flex tw-justify-end tw-text-base">
              {/* {(() => {
                const totalDrums = data.calculations.reduce(
                  (sum, item, index) => {
                    const selectedClass = selectedClasses[index] || "III";
                    return sum + resolveClassData(item, selectedClass).drums;
                  },
                  0,
                );

                return ( */}
                  <>
                    Resin cost for the {finalData.estimateDrums} drums for
                    Resiline {resin} =
                    <span className="tw-text-[#00B5ED] tw-font-semibold tw-text-xl">
                      ${(finalData.estimateDrums * resinCost).toLocaleString()}
                    </span>
                  </>
                {/* );
              })()
              } */}
            </p>

            <div>
              <strong>NOTE:</strong>
              <ul>
                {/* <li>
                  Liner thickness is based on ASTM F1216 Non-Mandatory Design
                  Appendix X1.
                </li>
                <li>
                  Class II design is to bridge a 1 inch (25 mm) max circular
                  hole in the pipe wall.
                </li>
                <li>Max. Liner thickness for NSF61 is 0.55 inch (14 mm).</li> */}
                <li>
                  Final resin volume includes 10% allowance and approximate
                  number of drums reported
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* {userType === "applicator" && (
        <div className="tw-flex tw-justify-end tw-w-full tw-mb-10 md:tw-mb-20">
          {isLoading ? (
            <LoadingButton />
          ) : (
            <Button variant="default" onClick={handleAddToCart} className="">
              <div className="tw-font-semibold tw-text-sm">Proceed</div>
            </Button>
          )}
        </div>
      )} */}

      <AlertDialog
        open={isClassIVDialogOpen}
        onOpenChange={setIsClassIVDialogOpen}
      >
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Important Notice</AlertDialogTitle>
            <AlertDialogDescription>
              You have selected <strong>Class IV</strong>. To proceed, please
              contact SIPP Americas for further information.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={handleCancelClassIV}>
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              className="tw-bg-destructive hover:tw-bg-destructive/80"
              onClick={handleConfirmClassIV}
            >
              I Understand
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Toast Notifications */}
      <ToastViewport />
      {toastList.map(({ id, title, description, variant }) => (
        <Toast
          key={id}
          variant={variant}
          open={true}
          duration={Infinity}
          onOpenChange={(isOpen) => {
            if (!isOpen) removeToast(id);
          }}
          className="tw-flex tw-flex-col tw-text-center"
        >
          <ToastTitle>{title}</ToastTitle>
          <ToastDescription>{description}</ToastDescription>

          {/* Close Button */}
          <button
            onClick={() => removeToast(id)}
            className="tw-mt-3 tw-self-center tw-text-sm tw-font-medium tw-bg-white tw-px-2 tw-py-1 tw-text-black hover:tw-bg-white/80"
          >
            Close
          </button>
        </Toast>
      ))}
    </div>
  );
};

export default ProjectEstimator;
//Make selection of either class III or class IV to order.
